module.exports = __webpack_public_path__ + "static/media/akagi-lose.9a5dd91d.png";